import React from "react";
/** Components Import */
import { ToggleButton, ButtonGroup } from "react-bootstrap";

function ButtonRadio({
  className = "",
  itemClassName = "",
  size = "md", // 'sm' | 'md' | 'lg'
  vertical = false,
  items = [],
  checked,
  onChange = (e) => {},
}) {
  const ChangeRadio = (e) => {
    onChange(e.currentTarget.value);
  };

  return (
    <ButtonGroup className={className} size={size} vertical={vertical}>
      {items.map((item, index) => {
        return (
          <ToggleButton
            key={index}
            className={itemClassName}
            id={`radio-${item.value}-${item.text}`}
            type="radio"
            variant={"outline-primary"}
            value={item.value}
            checked={checked == item.value}
            onChange={ChangeRadio}
          >
            {item.text}
          </ToggleButton>
        );
      })}
    </ButtonGroup>
  );
}

export default ButtonRadio;
